import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import config from '../../config';

import { StringUtils, DateUtils, ArrayUtils } from '../../utils';
import { History as history, Routes as routes } from '../../navigation';
import { UserActions, ContextActions, PracticeActions, ToastActions } from '../../actions';
import { TitleBar, Button, CreatePractice, UpgradePractice } from  '../../components'

class CreatePracticeScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      is_updgrade: false,
    }
    this.socket = null;
  }

  componentDidMount() {
    let props       = this.props.location && this.props.location.state && this.props.location.state.props ? this.props.location.state.props : null;
    let is_updgrade = props && props.is_updgrade && props.is_updgrade === true ? true : false;
    this.setState({ ...this.state, is_updgrade: is_updgrade });
  }

  renderCreatePractice = () => {
    let is_updgrade          = this.state.is_updgrade;
    let current_subscription = this.props.practice && this.props.practice.practiceSubscription ? this.props.practice.practiceSubscription : {};
    let practice             = this.props.practice && this.props.practice.practice ? this.props.practice.practice : {};

    return <div className='flex-container-column' style={{ padding: 15 }}>
      { is_updgrade ? <UpgradePractice
                        full_screen={true}
                        token={this.props.user.auth.token}
                        user_id={this.props.user.auth.user_id}
                        subscription={current_subscription}
                        toastActions={this.props.toastActions}
                        practice={practice}
                        practiceActions={this.props.practiceActions}
                      />
                    : <CreatePractice
                        full_screen={true}
                        token={this.props.user.auth.token}
                        user_id={this.props.user.auth.user_id}
                        toastActions={this.props.toastActions}
                        practiceActions={this.props.practiceActions}
                      /> }

    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column flex-center-align">
        { this.renderCreatePractice() }
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    practice: state.practice,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    practiceActions: bindActionCreators(
     { ...PracticeActions }, dispatch),
    toastActions: bindActionCreators(
     { ...ToastActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePracticeScreen)
